import React, { useCallback, useContext, useEffect } from "react";
import styles from "./package.module.css";
import { BurgerMenuContext } from "context/sidebar";
import IconButton from "common/IconButton";
import JourneyIncludeElements from "components/Package/JourneyIncludeElements";
import { getAll } from "utils/queries";
import Badge from "common/Badge";
import { groupedData } from "utils";

const JourneyPackage = ({
  setTickets,
  tickets,
  oldTickets,
  type,
  journey_id,
  event_id,
  buttonLabel,
  label,
  description,
  sidebarRef,
  TicketAndPackage,
}) => {
  const burgerContext = useContext(BurgerMenuContext);

  const updateSidebar = useCallback((updatedTickets) => {
    burgerContext.updateComp({
      comp: (
        <JourneyIncludeElements
          setTickets={setTickets}
          tickets={updatedTickets}
          handleVariants={handleVariants}
          sidebarRef={sidebarRef}
          type={type}
        />
      ),
      right: true,
      isOpen: true,
    });
    burgerContext.setShowSideBar(true);
  }, [burgerContext, setTickets, sidebarRef, type]);

  const handleVariants = useCallback(({ variant_index, ticket_index, checked }) => {
    if (type === "package") {
      setTickets(prevTickets => {
        const updatedTickets = prevTickets.map((ticket, index) => {
          if (index === ticket_index) {
            return {
              ...ticket,
              checked: checked,
              variants: ticket.variants.map(variant => ({
                ...variant,
                checked: checked
              }))
            };
          }
          return ticket;
        });
        
        // Schedule sidebar update after state is updated
        setTimeout(() => updateSidebar(updatedTickets), 0);
        return updatedTickets;
      });
    } else {
      setTickets(prevTickets => {
        const updatedTickets = [...prevTickets];
        updatedTickets[ticket_index].variants[variant_index] = {
          ...updatedTickets[ticket_index].variants[variant_index],
          checked: checked,
        };
        
        // Schedule sidebar update after state is updated
        setTimeout(() => updateSidebar(updatedTickets), 0);
        return updatedTickets;
      });
    }
  }, [type, updateSidebar]);

  const getAllVariants = useCallback(async () => {
    try {
      const url = event_id 
        ? `ticket/ticketVariants/${type}/${event_id}`
        : `ticket/ticketVariants/${type}`;
      const result = await getAll(url, false);
      if (!result?.data?.data?.rows) return;

      const selectedPackageIds = new Set();
      const selectedVariantIds = new Set();

      oldTickets?.forEach(ticket => {
        if (ticket.checked) {
          selectedPackageIds.add(ticket.package_id);
        }
        ticket?.variants?.forEach(variant => {
          if (variant.checked) {
            selectedVariantIds.add(variant.variant_id);
          }
        });
      });

      const processedTickets = result.data.data.rows.map(ticket => ({
        ...ticket,
        checked: type === "package" ? selectedPackageIds.has(ticket.package_id) : false,
        variants: ticket.variants?.map(variant => ({
          ...variant,
          checked: selectedVariantIds.has(variant.variant_id)
        })) || []
      }));

      setTickets(processedTickets);
    } catch (error) {
      console.error('Error fetching variants:', error);
    }
  }, [type, oldTickets, setTickets, event_id]);

  useEffect(() => {
    if (type) {
      getAllVariants();
    }
  }, [type, journey_id, oldTickets?.length, event_id]);

  return (
    <div className={styles.includeElements} ref={sidebarRef}>
      <div className={styles.includelabels}>{label}</div>
      <div className={styles.packageSubLabels}>{description}</div>

      {tickets
        ?.filter((e) => type === "package" ? e?.checked : e?.variants?.filter((v) => v?.checked)?.length > 0)
        ?.map((ticket, i) => (
          <div key={type === "package" ? 
            `selected-package-${ticket.package_id}-${i}` : 
            `selected-ticket-${ticket.ticket_id}-${i}`} 
            className={styles.includedItems}
          >
            <div className={styles.includes}>
              <div className={styles?.ticket_image} style={{ backgroundImage: `url(${ticket?.image_url})`,backgroundRepeat: "no-repeat",backgroundSize: "cover" }} />
              <div className={styles.info}>
                {type === "package" ? (
                  <div className={styles.label}>{ticket?.name}</div>
                ) : (
                  <div className={styles.label}>{ticket?.ticket_name}</div>
                )}
                <div className={styles.variantTicets}>
                  {type === "package" ? (
                    <Badge key={`badge-package-${ticket.package_id}`} label={ticket?.name} />
                  ) : (
                    ticket?.variants
                      ?.filter((v) => v?.checked)
                      ?.map((ee, index) => (
                        <Badge
                          key={`badge-variant-${ticket.ticket_id}-${index}`}
                          label={ee?.variant_name || ticket?.ticket_name}
                        />
                      ))
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}

      <IconButton
        overrideButtonStyles={styles.overrideButtonStyles}
        buttonLabel={buttonLabel}
        icon={"addBlack"}
        type="button"
        buttonFunction={(e) => {
          e.preventDefault();
          updateSidebar(tickets);
        }}
      />
    </div>
  );
};

export default JourneyPackage;
